<template>
  <div class="cardsales-agreements" v-if="terms">
    <div class="cardsales-agreements__container">
      <AgreementItem
        inputId="cardsales-agreements-all"
        label="아래 내용에 모두 동의합니다."
        :isAgreed.sync="isAllAgreed"
        :disabled="isLoading"
        @update:isAgreed="toggleAgreeAll"
      />
      <hr style="margin: 15px 0; border-top: 0;" />
      <ValidationObserver ref="validform" class="cardsales-agreements__items">
        <div v-for="term in terms" :key="term.uuid">
          <AgreementItem
            v-if="term.code.indexOf('personal_optional_o_') === -1"
            :inputId="term.uuid"
            :code="term.code"
            :title="term.title"
            :isAgreeRequired="term.is_required"
            :isAgreed.sync="term.is_agreed"
            :disabled="isLoading"
            @update:isAgreed="checkAgreeAll(term.code, $event)"
          />
          <AgreementChildItem
            v-else-if="term.code.indexOf('personal_optional_o_') === 0"
            :inputId="term.uuid"
            :code="term.code"
            :title="term.title"
            :isAgreeRequired="term.is_required"
            :isAgreed.sync="term.is_agreed"
            :disabled="isLoading"
            @update:isAgreed="checkAgreeAll(term.code)"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import termsApi from '@/api/now/termsApi'
import AgreementItem from './AgreementItem.vue'
import AgreementChildItem from './AgreementChildItem.vue'

export default {
  components: { AgreementItem, AgreementChildItem },
  props: {
    isRequiredAllAgreed: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      terms: null,
      testAgree: false,
      isAllAgreed: false,
    }
  },
  async created() {
    const { data } = await termsApi.getTerms()
    // 1 개인(신용)정보 선택적 수집·이용·제공 동의서 관련 약관이 아닌것만 먼저 목록에 넣음
    let arrTerms = data.filter((term) => term.type === 'agreement' && term.is_active === true && term.code.indexOf('personal_optional_o') === -1)
      .map(obj => ({ ...obj, is_agreed: false }))

    // 2 그 다음이 개인(신용)정보 선택적 수집·이용·제공 동의서
    let personalOptionParent = data.find((term) => term.type === 'agreement' && term.is_active === true && term.code === 'personal_optional_o')
    if (personalOptionParent) {
      personalOptionParent.is_agreed = false
      arrTerms.push(personalOptionParent)
    }

    // 3 그 다음이 개인(신용)정보 선택적 수집·이용·제공 동의서 세부 동의
    let personalOptionChildren = data.filter((term) => term.type === 'agreement' && term.is_active === true && term.code.indexOf('personal_optional_o_') === 0).map(obj => ({ ...obj, is_agreed: false }))
    arrTerms = arrTerms.concat(personalOptionChildren)

    this.terms = arrTerms
  },
  methods: {
    toggleAgreeAll() {
      this.terms.forEach(term => {
        term.is_agreed = this.isAllAgreed
      })
      this.$nextTick(_ => {
        this.$refs.validform.validate()
      })
      this.checkAgreeAll()
    },
    checkPersonalOptionalTerms(nowChangeTermCode, isNowChangeTermChecked) {
      // 개인정보 선택적 동의
      if (nowChangeTermCode === 'personal_optional_o') {
        // 상위 동의가 변경되는 경우
        // 활성화 -> 하위 모두 활성화
        // 비활성화 -> 하위 모두 비활성화
        this.terms.forEach(term => {
          if (term.code.indexOf('personal_optional_o_') === 0) {
            term.is_agreed = isNowChangeTermChecked
          }
        })
      } else if (nowChangeTermCode.indexOf('personal_optional_o_') === 0) {
        // 하위 동의가 변경되는 경우
        // 활성화 -> 상위 동의 활성화
        // 하위 동의 모두 비활성화 -> 상위 동의 비활성화

        // 하위 동의중 하나라도 활성화인지 검사
        const isSubPersonalOptionChecked = this.terms.some(term => {
          return term.code.indexOf('personal_optional_o_') === 0 && term.is_agreed === true
        })

        // 하나라도 활성화면 상위동의도 활성화,
        // 모두 비활성화면 상위 동의 비활성화
        for (let i = 0; i < this.terms.length; i++) {
          if (this.terms[i].code === 'personal_optional_o') {
            this.terms[i].is_agreed = isSubPersonalOptionChecked
            return
          }
        }
      }
    },
    checkAgreeAll(nowChangeTermCode, isNowChangeTermChecked) {
      // 개인정보 선택적 동의서 관련 동의 내용들이 변경되는 경우
      if (nowChangeTermCode && nowChangeTermCode.indexOf('personal_optional_o') === 0) {
        this.checkPersonalOptionalTerms(nowChangeTermCode, isNowChangeTermChecked)
      }

      this.$emit('update:isRequiredAllAgreed', this.terms.every(term => {
        if (term.is_required) {
          return term.is_agreed
        }

        return true
      }))

      this.isAllAgreed = this.terms.every(term => term.is_agreed)
    }
  }
}
</script>
<style lang="scss" scoped>
.cardsales-agreements {
  &__container {
    margin: 0 auto;
    padding: 0 6.66%;
  }
  // 마케팅 동의 수단이 table-cell이라
  &__items {
     display: table;
  }
  &__items > div:not(:last-child) {
    margin-bottom: 12px;
  }
}
</style>
